import React from "react";
import "./index.css";
import ImageUpload from "../../../layout/ImageUpload/index";

const SpeakerPhotoWebinar = ({id, zoom}) => {
  return (
    <div id={id} className="template" style={{"--zoom-level": zoom}}>
      <div className="upload-wrap">
        <ImageUpload id={id} />
      </div>
    </div>
  );
};

export default SpeakerPhotoWebinar;
